import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getWidgetsSummaryMetrics = {
  name: "getWidgetsSummaryMetrics" as const,
  input: z
    .object({
      dateRange: z
        .object({ start: zExt.plainDate(), end: zExt.plainDate() })
        .optional(),
      widgetId: zExt.objectId().optional(),
    })
    .nullable(),
  output: z.object({
    // TODO(paul): use MoneySchema
    salesGeneratedByWidgets: z.object({
      shopCurrency: createEnum(Currency),
      value: z.number().optional(),
    }),
    checkoutConversionRate: z.number().optional(),
    numCheckoutVisits: z.number().optional(),
    numCheckoutCompletions: z.number().optional(),
    // TODO(paul): use MoneySchema
    revenueLiftPerOrder: z.object({
      shopCurrency: createEnum(Currency),
      value: z.number().optional(),
    }),
  }),
};
